module.exports = __webpack_public_path__ + "static/img/chensjali.e5dceeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chensjali.png
// module id = oTAW
// module chunks = 1